module.exports = __webpack_public_path__ + "img/rowC19.1a15335f.png";